import { ComposantTemplateSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const ComposantTemplateModel: SelectorModel = {
  name: 'composantTemplates',
  getSelector: ComposantTemplateSelectors.selectAllComposantTemplatesDictionary,
  isReady: ComposantTemplateSelectors.selectIsReadyComposantTemplate
};
